import React, { useEffect } from "react";
import AOS from "aos";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import TeamIllustration from "../Assest/images/About us page.gif";
import Team1 from "../Assest/images/team1.png";
import Team2 from "../Assest/images/team2.png";
import Team3 from "../Assest/images/team3.png";
import Button from "../components/Button";
import Video from "../components/Video";
import videoSrc from "../Assest/perfume.mp4";
import img1 from "../Assest/images/hero2.jpg";
import img2 from "../Assest/images/c1.png";
import { FaAward } from "react-icons/fa";

function Aboutus() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const services = [
    {
      title: "Web designing",
      description:
        "The point of using Lorem Ipsum is that it has a more-or-less normal.",
      icon: "🎨",
    },
    {
      title: "Web development",
      description:
        "The point of using Lorem Ipsum is that it has a more-or-less normal.",
      icon: "💻",
    },
    {
      title: "Web application",
      description:
        "The point of using Lorem Ipsum is that it has a more-or-less normal.",
      icon: "📱",
    },
  ];

  const faqs = [
    {
      question: "Integer cursus molestie lorem sit ac ipsum?",
      answer:
        "Suspendisse felis sem, viverra non leo id, pretium rhoncus lorem. Nulla facilisi lorem ipsum dolor sit amet.",
    },
    {
      question: "Maecenas condimentum sollicitudin ligula?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    },
    {
      question: "Duis hendrerit sit amet tellus maximus?",
      answer: "Nulla facilisi. Sed do eiusmod tempor incididunt ut labore.",
    },
  ];

  return (
    <div className="w-screen mx-auto overflow-hidden pt-[6rem]">
      {/* </section> */}
      <section className="relative w-full h-[500px] overflow-hidden">
        {/* Background Video */}
        <motion.section
          key={1}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="container mx-auto px-4 sm:px-6"
        >
          <video
            src={videoSrc}
            autoPlay
            loop
            muted
            className="absolute top-0 left-0 w-full h-full object-fill"
          />

          <div className="absolute inset-0 bg-black opacity-40"></div>
          <div className="absolute bottom-10 left-10 text-white">
            <h1 className="text-4xl md:text-6xl font-bold">About Us</h1>
          </div>
        </motion.section>
      </section>

      {/* about */}

      <section className="relative py-32">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap -mx-4">
            {/* Content Column */}
            <div
              className="w-full lg:w-1/2 px-4 mb-10 lg:mb-0"
              data-aos="flip-right"
            >
              <div className="pt-12 pr-0 lg:pr-24">
                <div className="mb-10">
                  <div className="relative text-[#d7a449] text-lg font-bold mb-4 inline-block pr-12">
                    About Us
                    <span className="absolute right-0 bottom-2 w-10 h-[1px] bg-gray-400"></span>
                  </div>
                  <h2 className="text-4xl font-bold leading-tight">
                    We Are The Leader In <br /> The Interiores
                  </h2>
                </div>
                <p className="text-gray-600 text-base leading-relaxed mb-10">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries
                </p>
                <div className="text-gray-900 font-bold mb-12">
                  Request Quote:{" "}
                  <span className="text-[#d7a449]">freequote@gmail.com</span>
                </div>
                <a
                  href="about.html"
                  className="relative inline-block px-10 py-3 text-gray-900 text-sm font-bold 
  bg-white border-2 border-[#d7a449] hover:bg-[#d7a449] hover:text-white 
  transition-all duration-300 group"
                >
                  <span className="relative z-10">Read More</span>
                  {/* Adding a shadow effect instead of pattern */}
                  <div
                    className="absolute left-2 top-2 -right-2 -bottom-2 bg-gray-100 
  transition-all duration-300 -z-10 group-hover:bg-[#d7a449]/20"
                  ></div>
                </a>
              </div>
            </div>

            {/* Image Column */}
            <div className="w-full lg:w-1/2 px-4 mb-12" data-aos="flip-left">
              <div className="relative pl-12 pt-10">
                {/* Border Design */}
                <div className="absolute right-0 top-0 left-10 bottom-24 border-2 border-[#d7a449] -z-10"></div>

                <div className="relative">
                  <img src={img2} alt="about" className="w-full" />

                  {/* Pattern Overlay */}
                  <div
                    className="absolute left-2 top-2 -right-2 -bottom-2 bg-gray-100 
  transition-all duration-300 -z-10 group-hover:bg-[#d7a449]/20"
                  ></div>

                  {/* Experience Box */}
                  <div className="absolute left-10 bottom-12">
                    <div className="relative text-gray-900 text-2xl font-bold pl-32">
                      <span
                        className="absolute left-0 top-0 w-[110px] h-[110px] 
                    text-[#d7a449] text-[68px] font-bold leading-[105px] text-center 
                    bg-white border border-black"
                      >
                        5
                      </span>
                      Years <br /> Experience <br /> Working
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about 2 */}
      <section className="py-32">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap -mx-4">
            {/* Content Column */}
            <div
              className="w-full lg:w-1/2 px-4 mb-12 lg:order-2"
              data-aos="fade-left"
            >
              <div className="pl-8">
                <div className="mb-12">
                  <span className="block text-orange-500 text-lg font-medium mb-4">
                    About Luxe Fragrances
                  </span>
                  <h2
                    className="text-4xl text-gray-800 font-semibold mb-4 relative pb-5 
              after:content-[''] after:absolute after:left-0 after:bottom-0 
              after:w-12 after:h-[3px] after:bg-gray-300"
                  >
                    Crafting Luxury Scents Since 1995
                  </h2>
                </div>

                <p className="text-gray-600 text-base leading-7 mb-5">
                  At Luxe Fragrances, we've been creating exceptional perfumes
                  for over two decades. Our master perfumers blend the finest
                  ingredients from around the world to create signature scents
                  that capture the essence of luxury and sophistication. Each
                  fragrance is carefully crafted to tell its own unique story.
                </p>

                <p className="text-gray-600 text-base leading-7 mb-8">
                  We pride ourselves on using sustainable and ethically sourced
                  ingredients, combining traditional perfumery techniques with
                  modern innovation. Our commitment to quality ensures that each
                  bottle contains not just a fragrance, but an experience that
                  lasts throughout the day.
                </p>

                <div>
                  <a
                    href="#"
                    className="inline-block px-8 py-4 bg-orange-500 hover:bg-orange-600 
              text-white text-lg font-semibold transition-colors duration-300"
                  >
                    Explore Collection
                  </a>
                </div>
              </div>
            </div>

            {/* Image Column */}
            <div className="w-full lg:w-1/2 px-4 mb-12" data-aos="fade-right">
              <div className="relative pl-20 wow fadeInLeft">
                {/* Border Design */}
                <div
                  className="absolute w-[calc(50%+80px)] h-[calc(100%+160px)] 
            top-[-80px] left-[-3px] z-0 border-[44px] border-orange-500"
                ></div>

                {/* Author Description */}
                <div
                  className="absolute bottom-4 left-24 z-10 bg-orange-500 
            py-2.5 px-4 w-[calc(100%-152px)] rounded-full"
                >
                  <h2 className="text-xl text-white text-center m-0">
                    Pierre Laurent
                  </h2>
                  <span
                    className="block text-base tracking-[6px] text-white 
              text-center font-normal"
                  >
                    Master Perfumer
                  </span>
                </div>

                {/* Main Image */}
                <figure className="relative z-[1]">
                  <a href="#" className="block">
                    <img
                      src={img2}
                      alt="Master Perfumer at Work"
                      className="rounded-[46px] shadow-[0_30px_50px_rgba(8,13,62,0.15)]"
                    />
                  </a>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">
              Services we're offering to our customers
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="p-6 border-t-4 border-r-4 border-orange-500 rounded-lg shadow-lg text-center transition-all duration-700 ease-in-out hover:border-4"
                data-aos="zoom-in"
              >
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-xl font-semibold">{service.title}</h3>
                  <span className="text-3xl">{service.icon}</span>
                </div>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <button className="text-gray-500 hover:text-red-500 flex items-center gap-2">
                  Read more →
                </button>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600 mb-4">
              Trust the experts for all your web design & development needs
            </p>
            <button className="px-8 py-3 bg-red-500 text-white rounded-full hover:bg-red-600">
              Explore now
            </button>
          </div>
        </div>
      </div>

      {/* Customer Testimonials */}
      <section className="text-center mb-16 px-6 md:px-20">
        <h2 className="text-3xl font-semibold mb-6" data-aos="fade-up">
          What Our Customers Say
        </h2>
        <p className="text-gray-700 italic" data-aos="zoom-in">
          "Amazing service and quality products! Highly recommend this store."
        </p>
        <p className="text-gray-600 mt-2">- Sarah Williams</p>
      </section>

      {/* Contact Section */}
      <section className="text-center px-6 md:px-20">
        <h2 className="text-3xl font-semibold mb-6" data-aos="fade-up">
          Get in Touch
        </h2>
        <p className="text-gray-700 mb-4">
          Have questions? Reach out to us anytime.
        </p>
        <Link to="/contact">
          <Button text="Contact" />
        </Link>
      </section>
    </div>
  );
}

export default Aboutus;
